<template>

<com-item name="size.lifespan" :size="size" :loading="loading" title="Lifespan" :is-empty="!active" >

	<template v-slot:about>

		<p>See how long games stay in {{ your }} collection.</p>

		<p class="small">Click a bar to view full list of games.</p>

	</template>

	<template v-slot:buttons>

		<com-toggle :options="settings.period.options" :value="settings.period.value" v-on:change="onPeriodChange" />

	</template>

	<template v-slot:stats>

		<div class="lifespan" v-if="active">

			<div class="lifespan-list">

				<div class="lifespan-list-shading">
					<div class="lifespan-list-shading-item">0 - 1yr</div>
					<div class="lifespan-list-shading-item">1 - 2yr</div>
					<div class="lifespan-list-shading-item">2 - 3yr</div>
					<div class="lifespan-list-shading-item">3 - 4yr</div>
					<div class="lifespan-list-shading-item">4 - 5yr</div>
					<div class="lifespan-list-shading-item">5 - 6yr</div>
					<div class="lifespan-list-shading-item">6 - 7yr</div>
					<div class="lifespan-list-shading-item">7 - 8yr</div>
					<div class="lifespan-list-shading-item">8 - 9yr</div>
					<div class="lifespan-list-shading-item">9 - 10yr</div>
				</div>

				<div class="lifespan-list-item" v-on:click="onClick(index)" v-tooltip="tooltip(duration, index)" v-for="(duration, index) in lifespan" :key="index">
					<div :style="height(duration)"></div>
				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' || this.fetching === 'lifespan.expansions' || this.fetching === 'lifespan.period'

		},

		active: function() {

			return this.lifespan.length && !this.loading

		},

		lifespan: function() {

			return this.$store.getters['page/insights/size/lifespan']

		},

		max: function() {

			return this.$_.max(this.lifespan, function(duration) {

				return duration

			})

		},

		settings: function() {

			var settings = {}

			settings.expansions = {
				options: [
					{value: 1, text: 'With expansions'},
					{value: 0, text: 'Without expansions'}
				],
				value: this.$store.getters['filter/insights/size/lifespan/expansions']
			}

			settings.period = {
				options: [
					{value: 0, text: 'Past and present'},
					{value: 1, text: 'Current games'},
					{value: 2, text: 'Past games'}
				],
				value: this.$store.getters['filter/insights/size/lifespan/period']
			}

			return settings

		}

	},

	methods: {

		onPeriodChange: function(value) {

			this.$store.commit('filter/insights/size/lifespan/period', value)

		},

		onExpansionsChange: function(value) {

			this.$store.commit('filter/insights/size/lifespan/expansions', value)

		},

		onClick: function(index) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsSizeLifespan',
				index: index
			})

		},

		tooltip: function(value) {

			return '<small>' + value.toString() + ' game' + ((value === 1) ? '' : 's') + '</small>'

		},

		height: function(value) {

			return {
				height: ((100 / this.max) * value).toString() + '%'
			}

		}

	}

}

</script>

<style scoped>

.lifespan-list {
	width: 100%;
	height: 320px;
	display: flex;
	align-items: center;
}

.is-mobile .lifespan-list {
	height: 320px;
}

.lifespan-list-shading {
	z-index: 1;
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
}

.lifespan-list-shading-item {
	width: calc(100% / 10);
	height: 100%;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #a0c3cf;
	padding: 5px;
}

.lifespan-list-shading-item:nth-child(even) {
	background-color: rgba(12, 137, 178, 0.05);
}

.lifespan-list-item {
	height: 100%;
	padding: 25px 0px;
	width: calc(100% / 40);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;
}

.is-mobile .lifespan-list-item {
	height: 280px;
}

.lifespan-list-item:hover {
	background-color: rgba(12, 137, 178, 0.1);
}

.lifespan-list-item div {
	width: 50%;
	border-radius: 4px;
	min-height: 2px;
	background-color: #4881bb;
	transition: height 100ms linear;
}

</style>